import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiProviderService } from 'src/app/services/api-provider.service';

@Injectable({
  providedIn: 'root'
})
export class LocalizationService {

  headers: HttpHeaders;
  apiServer: string;

  constructor(private http: HttpClient, private apiRef: ApiProviderService) {
    this.headers = new HttpHeaders();
    this.headers.append('Content-Type', 'text');
    this.headers.append('Accept', 'text');
    this.apiServer = 'api/LabelKey/';
   }

   getDefaultLabelByKey(labelKey: string): Observable<string> {
    return this.http.get(
      this.apiRef.getApiUrl(`${this.apiServer}defaultLabel`, [{Key: 'labelKey', Value: labelKey}]), {responseType: 'text'})
        .pipe(map((result) => result));
   }

   getLabelByKey(labelKey: string): Observable<string> {
    return this.http.get(
      this.apiRef.getApiUrl(`${this.apiServer}label`, [{Key: 'key', Value: labelKey}]), {responseType: 'text'})
        .pipe(map((result) => result));
   }

   getHtmlText(labelKey: string, module: string): Observable<string> {
    return this.http.get(
      this.apiRef.getApiUrl(`${this.apiServer}GetHtmlText`,
        [{Key: 'key', Value: labelKey},{Key: 'module', Value: module}]), {responseType: 'text'})
        .pipe(map((result) => result));
   }
}
